export default __webpack_public_path__ + "static/media/cart-banner.904e3ead.jpg";